// extracted by mini-css-extract-plugin
module.exports = {"root":"errorPage_root__WD0TQ","container":"errorPage_container__DfJ0m","content":"errorPage_content__Ga_d1"};